module.exports = __webpack_public_path__ + "img/information_box.80c94af3.png";